import React from 'react'

import PropTypes from 'prop-types';

import Coupon from 'components/Coupon/Coupon';



const LLMCouponsPreview = ({ coupon, business }) => {
    coupon  = {...coupon, title: coupon?.title?.length > 35 ? coupon?.title.slice(0, 32) + '...' : coupon?.title}

    return (
      <div className="col-md-12">
        <h4 className="mb-3">Coupon Preview</h4>
        <div className="mb-4">
          <div>
            <Coupon data={coupon} businessData={business} previewMode={true} templateMode={false}/>
          </div>
          {/* <div style={{ marginLeft: 12, marginTop: 10 }}>
            <label>
              <input type="checkbox" /> Remove?
            </label>
          </div> */}
        </div>
      </div>
    );
}

  LLMCouponsPreview.propTypes = {
    coupon: PropTypes.object.isRequired,
    business: PropTypes.shape({
      logo: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
  };

export default LLMCouponsPreview
